import UiDropzone from "@/react/story/components/ui/UiDropzone";
import UiRange from "@/react/story/components/ui/UiRange";
import { DEFAULTS } from "@/react/story/data";
import type { Config, Separator } from "@/react/story/types";

type Props = {
    separator: Separator;
    saveSeparator: (separator: Separator | null) => void;
}

export default function UiSeparator(props: Props) {
    const setConfig = (config: Partial<Config>) => {
        props.saveSeparator({
            ...props.separator,
            config: {
                ...props.separator.config,
                ...config
            }
        });
    };

    return (
        <div className="d-flex flex-column gap-3">
            <div>
                <strong className="d-block">Image</strong>
                <UiDropzone
                    defaultValue={props.separator.config.backgroundImage}
                    canDelete={true}
                    onChange={backgroundImage => setConfig({ backgroundImage })}
                />
            </div>
            <div>
                <strong className="d-block">Largeur</strong>
                <UiRange
                    defaultValue={props.separator.config.flexBasis || DEFAULTS.flexBasis}
                    onChange={flexBasis => setConfig({ flexBasis })}
                />
            </div>
            <div className="d-flex justify-content-end">
                <button
                    type="button"
                    className="btn btn-outline-danger"
                    onClick={() => props.saveSeparator(null)}
                >
                    <span className="bi-trash"></span>
                    Retirer le séparateur
                </button>
            </div>
        </div>
    );
}
